import React, { ReactNode, useEffect, useState } from "react";
import { imageGallery as listingStayImageGallery } from "./constant";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import ListingImageGallery from "components/ListingImageGallery/ListingImageGallery";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import MobileFooterSticky from "./(components)/MobileFooterSticky";
import { Alert } from "@mui/material";
import { connect } from "react-redux";
import api from "../../api";

const DetailPagetLayout = ({ children, brand, user }) => {
  const navigate = useNavigate();
  const thisPathname = useLocation().pathname;
  const [searchParams] = useSearchParams();
  const modal = searchParams?.get("modal");
  const [isOwnBrand, setIsOwnBrand] = useState(false);

  const handleCloseModalImageGallery = () => {
    let params = new URLSearchParams(document.location.search);
    params.delete("modal");
    navigate(`${thisPathname}?${params.toString()}`);
  };

  const getImageGalleryListing = () => {
    if (!brand?.images?.length) return [];
    return brand.images.map((img, id) => ({
      id,
      url: `${api.getUploadUrl()}/${img.url}`,
      caption: img.caption
    }));
  };

  useEffect(() => {
    setIsOwnBrand(user?.company?.id === brand?.brandowner?.id);
  }, [brand, user]);

  return (
    <div className="ListingDetailPage">
      {isOwnBrand && (
        <Alert severity="info" className="sticky top-[100px] justify-center mb-4 z-20">
          Currently viewing brand profile as a agency would see it
        </Alert>
      )}
      <ListingImageGallery
        isShowModal={modal === "PHOTO_TOUR_SCROLLABLE"}
        onClose={handleCloseModalImageGallery}
        images={getImageGalleryListing()}
      />

      {brand?.showroom_video?.url && (
        <ListingImageGallery
          isShowModal={modal === "VIDEO_FOCUS"}
          onClose={handleCloseModalImageGallery}
          images={[{ id: 1, url: `${api.getUploadUrl()}/${brand.showroom_video.url}` }]}
        />
      )}

      <div className="container ListingDetailPage__content">{children}</div>

      {/* OTHER SECTION */}
      <div className="container py-24 lg:py-32">
        {/* <div className="relative py-16">
          <BackgroundSection />
          <SectionSliderNewCategories
            heading="Explore by types of stays"
            subHeading="Explore houses based on 10 types of stays"
            categoryCardType="card5"
            itemPerRow={5}
            sliderStyle="style2"
            uniqueClassName="ListingDetailPage"
          />
        </div> */}
      </div>

      {/* STICKY FOOTER MOBILE */}
      <MobileFooterSticky />
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  brand: state.brand.brand,
});

export default connect(mapStateToProps, {})(
  DetailPagetLayout
);
